import React, { useState, useEffect } from "react";

const Operation = () => {
    return (
        <div>operation</div>
    )
}

export { Operation }